/**
 * ColumnVisibilityPanel.jsx
 * ─────────────────────────
 * Slide-in drawer for toggling column visibility.
 * Shows/hides individual columns with instant feedback.
 */

import React from 'react';
import { LIFECYCLE_COLUMNS } from './lifecycleColumnManifest';

export default function ColumnVisibilityPanel({
  open,
  onClose,
  columnVisibility,
  onToggle,
  onShowAll,
  onHideAll,
  columns = LIFECYCLE_COLUMNS,
}) {
  if (!open) return null;

  return (
    <div className="gv-col-panel-overlay" onClick={onClose}>
      <div className="gv-col-panel" onClick={e => e.stopPropagation()}>
        <div className="gv-col-panel-header">
          <h3 className="gv-col-panel-title">Columns</h3>
          <button type="button" className="gv-col-panel-close" onClick={onClose}>&times;</button>
        </div>
        <div className="gv-col-panel-actions">
          <button type="button" className="lrc-btn gv-col-action-btn" onClick={onShowAll}>Show all</button>
          <button type="button" className="lrc-btn gv-col-action-btn" onClick={onHideAll}>Hide all</button>
        </div>
        <div className="gv-col-panel-list">
          {columns.map(col => (
            <label key={col.key} className="gv-col-panel-item">
              <input
                type="checkbox"
                checked={columnVisibility[col.key] !== false}
                onChange={() => onToggle(col.key)}
              />
              <span className="gv-col-panel-label">{col.label}</span>
              {col.readOnly && <span className="gv-col-panel-badge">read-only</span>}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
